'use client';

export function YourPrivacyChoicesButton() {
  return (
    <button
      type="button"
      aria-haspopup="dialog"
      className="foot-link-button"
      onClick={() => {
        window.Cookiebot?.renew?.();
      }}
    >
      Cookie preferences
    </button>
  );
}
